import {
  Component,
  OnInit,
  EventEmitter,
  Injectable,
  AfterViewInit
} from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService } from '../cognito/user-login.service';
import * as Materialize from 'angular2-materialize/dist/index';
import { NavbarService } from './navbar.service';
import { ProjectsService } from '../projects/projects.service';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { ProjectDataService } from '../shared/dataservice.service';
import { Subscription } from 'rxjs/Subscription';
import { CommonService } from './searchCommon.service';
import { SendSupportEmailService } from '../shared/send-support-email.service';
import { AdvancedSearchComponent } from '../search/advanced/advancedsearch.component';
import { BasicSearchComponent } from '../search/basic/basicsearch.component';

// import { ProjectsComponent } from "../projects/projects.component";
declare let JQuery: any;
declare let $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.css'],
  providers: [UserLoginService, SendSupportEmailService]
})
export class NavbarComponent implements OnInit, AfterViewInit {
  private subscription: Subscription;

  errorMessage: string;
  changepassworderror = false;
  changepasswordmessage = '';
  passwordmatchmessage: boolean = false;
  passwordrequiredmessage: boolean = false;
  changepasswordicon = '';
  messagerequiredmessage: boolean = false;
  showCarotbool: boolean = false;
  confirmpassword: string = '';
  oldpassword: string = '';
  newpassword: string = '';
  // current: number = 0;
  passwordModalAction = new EventEmitter<string | MaterializeAction>();
  supportModalAction = new EventEmitter<string | MaterializeAction>();
  modalActions = new EventEmitter<string | MaterializeAction>();
  route: string;
  public supportMessage: string;
  public filter1: string = '';
  public supportSubject: string;

  constructor(
    private projectsService: ProjectsService,
    private router: Router,
    private projectDataService: ProjectDataService,
    private commonService: CommonService,
    private userLoginService: UserLoginService,
    public navService: NavbarService,
    public sendSupportEmailService: SendSupportEmailService
  ) { }

  ngOnInit() {
    this.subscription = this.commonService.notifyObservableReverse$.subscribe(
      res => {
        if (res.hasOwnProperty('option') && res.option === 'setActive') {
          console.log('called from project component');
          this.navService.setNavID(0);
          // this.current = 0;
          // perform your other action from here
        }
      }
    );
  }

  ngOnDestroy() {
    this.passwordModalAction.emit({ action: 'modal', params: ['close'] });
    this.supportModalAction.emit({ action: 'modal', params: ['close'] });
    this.modalActions.emit({ action: 'modal', params: ['close'] });
  }

  ngAfterViewInit() {
    let route = this.router.url;
    console.log(' Route = ', route);
    if (route === '/useradmin') {
      this.navService.setNavID(3);
      // this.current = 3;
      if (!$('#settings').hasClass('active')) {
        document.getElementById('settings').click();
      }
    }
  }

  onWorkspace(flag?: boolean) {
    this.collapseMenuAccordion();
    if (flag) {
      this.mobileMenuHide();
     }
    console.log('projects Clicked');
    if ($('#settings').hasClass('active')) {
      document.getElementById('settings').click();
    }
    this.router.navigate(['/workspace']);
    this.navService.setNavID(0);
    // this.current = 0;
  }

  onProjects(flag?: boolean) {
    this.collapseMenuAccordion();
    if (flag) {
      this.mobileMenuHide();
     }
    this.projectDataService.setForceUpdateBool(true);
    console.log('projects Clicked');

    if ($('#settings').hasClass('active')) {
      document.getElementById('settings').click();
    }
    // Code will check if the user is already in projects, then it will refresh project list.
    if (this.navService.currenturlnavid !== 1) {
      this.router.navigate(['/projects']);
    } else {
      this.commonService.notifyOther({ option: 'onProjectSearchFromNav', value: '' });
    }
    this.navService.setNavID(1);
    // this.current = 1;
  }

  onCustomers(flag?: boolean) {
    this.collapseMenuAccordion();
    if (flag) {
      this.mobileMenuHide();
     }
    this.navService.setNavID(2);
    // this.current = 2;
    if ($('#settings').hasClass('active')) {
      document.getElementById('settings').click();
    }
    console.log('customers Clicked');
    this.router.navigate(['/customers']);
  }

  onSettings() {
    // this.current = 10;
    this.router.navigate(['/useradmin']);
    this.navService.setNavID(3);
    // this.current = 3;
  }

  onUserAdmin(flag?: boolean) {
    if (flag) {
      this.mobileMenuHide();
    }
    this.router.navigate(['/useradmin']);
    this.navService.setNavID(3);
    // this.current = 3;
  }

  onResourceAdmin() {
    this.router.navigate(['/resourceadmin']);
    this.navService.setNavID(4);
    // this.current = 4;
  }

  onMaterialAdmin() {
    this.router.navigate(['/materialadmin']);
    this.navService.setNavID(5);
    // this.current = 5;
  }

  onShapeSearch() {
    this.navService.setNavID(7);
    // this.current = 7;
  }

  onQuote() {
    this.collapseMenuAccordion();
    this.router.navigate(['/quote']);
    this.navService.setNavID(8);
    // this.current = 8;
  }

  onAccountAdmin() {
    this.router.navigate(['/accountadmin']);
    this.navService.setNavID(11);
    // this.current = 11;
  }

  onLogout() {
    localStorage.setItem('token', '');
    localStorage.setItem('id_token', '');
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.setItem('mr_planid', null);
    this.userLoginService.logout();
    this.router.navigate(['/login']);
  }

  showCarot() {
    this.showCarotbool = true;
  }

  clearSearch() {
    this.filter1 = '';
    this.showCarotbool = false;
    this.commonService.notifyOther({ option: 'onProjectSearchFromNav', value: '' });
  }

  openPasswordModal() {
    this.confirmpassword = '';
    this.oldpassword = '';
    this.newpassword = '';
    this.changepassworderror = false;
    this.changepasswordmessage = '';

    this.passwordModalAction.emit({ action: 'modal', params: ['open'] });
  }

  changePassword() {
    console.log('Updating password');

    this.changepassworderror = false;

    if (!this.oldpassword || !this.newpassword || !this.confirmpassword) {
      this.changepassworderror = true;
      this.changepasswordmessage = 'All fields are required';
      return;
    }

    if (this.newpassword !== this.confirmpassword) {
      this.changepassworderror = true;
      this.changepasswordmessage = 'New password and confirm password do not match.';
      return;
    }

    Materialize.toast('Updating password...', 3000);
    this.userLoginService.changePassword(this.oldpassword, this.newpassword, this);
  }

  passwordChanged(message: string) {
    if (message != '') {
      // error
      this.changepassworderror = true;
      this.changepasswordmessage = message;
    } else {
      // success
      this.passwordModalAction.emit({ action: 'modal', params: ['close'] });
      Materialize.toast('Password updated', 5000);
    }
  }

  sendSupportEmail() {
    console.log('sendSupportEmail called');
    this.messagerequiredmessage = false;

    if (!this.supportSubject || !this.supportMessage) {
      this.messagerequiredmessage = true;
      console.log('Subject or message not filled in');
      return;
    }

    Materialize.toast('Sending support message...', 5000);

    this.sendSupportEmailService
      .sendSupportEmail(this.supportSubject, this.supportMessage)
      .subscribe(
        data => {
          console.log('Support email send successful');
          this.messagerequiredmessage = false;
          Materialize.toast('Support message sent.', 5000);
        },
        error => {
          this.errorMessage = <any>error;
          console.error('sendSupportEmail() error:', this.errorMessage);
          this.messagerequiredmessage = false;
          Materialize.toast(
            'Error sending support message.  Please email support@machineresearch.com directly.',
            15000
          );
        }
      );
  }

  openSupportModal() {
    this.supportMessage = '';
    this.supportSubject = '';

    this.supportModalAction.emit({ action: 'modal', params: ['open'] });
  }

  changeValue(event: any) {
    console.log('new value : ' + event.value);
    this.commonService.notifyOther({
      option: 'onProjectSearchFromNav',
      value: event.value
    });
  }

  searchByProject() {
    let searchString = (<HTMLInputElement>document.getElementById('searchterm'))
      .value;
    console.log('new value : ' + searchString);
    this.commonService.notifyOther({
      option: 'onProjectSearchFromNav',
      value: searchString
    });
  }
  mobileMenuHide() {
    $('.button-collapse').sideNav('hide');
  }
  collapseMenuAccordion() {
    $('.collapsible').collapsible('close');
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/navbar/navbar.component.ts